import { render, staticRenderFns } from "./BookingBooth.vue?vue&type=template&id=9870204e&"
import script from "./BookingBooth.vue?vue&type=script&lang=js&"
export * from "./BookingBooth.vue?vue&type=script&lang=js&"
import style0 from "./BookingBooth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports